module.exports = __webpack_public_path__ + "static/media/magnet-plus.7466a179.png";